// Aos Library
import { updateLinksAttributes } from '../../utils/handleAttributes';
import { getWindowSize } from '../../utils/helpers';
const breakpointValue = 400;

function cardsWidget() {
  const widgetName = 'cardsWidget';
  const widgetOpts = cardsWidgetOpts;
  const $widget = $(`#${widgetName}`);

  saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: getWindowSize(breakpointValue) ? [''] : ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,
    maxItemsVisible: 6,
    itemsPerPanel: 1,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createcardsWidget(data.items, $widget);
      } else {
        $widget.remove();
      }
    },
  });
}

function createcardsWidget(widgetData, $widget) {
  $widget.find('.buttonwrap').remove();

  if (widgetData.length <= 3) {
    $widget.addClass('single-row');
  }

  $widget.find('.card-widget-item').each(function (x) {
    const { Title, URL } = widgetData[x];
    const $cardItem = $(this);
    $cardItem.append('<div class="overlay"><span class="icon"></span></div>');

    if (URL) {
      $cardItem
        .find('.card-content')
        .append(
          `<div class="btn-wrap alternative-btn"><a href="${URL}" class="button" ${updateLinksAttributes(URL, Title)}>More</a></div>`,
        );
    }

    updateLinksAttributes(URL, Title, $cardItem);
  });
}

export default function updateCards() {
  let isMobile;

  function triggerFeature() {
    const matches = globalThis.matchMedia(`(max-width: ${breakpointValue}px)`).matches;
    if (matches === isMobile) return;
    isMobile = matches;

    $('#cardsWidget').empty();
    cardsWidget();
  }
  triggerFeature();

  $(globalThis).on('resize', triggerFeature);
}
